import useBasicData from "./useBasicData";

/**
 * A variant of useBasicData that asserts workspace is non-null.
 * Use this in contexts where a workspace is guaranteed to exist (e.g., workspace routes).
 * Throws an error if workspace is null, indicating a programming error.
 */
export const useRequiredWorkspace = () => {
  const { workspace, ...rest } = useBasicData();

  if (!workspace) {
    throw new Error(
      "useRequiredWorkspace must be used within a workspace context",
    );
  }

  return { workspace, ...rest };
};
